<div class="filter-row">
  <dcc-billboard
    label="Devices"
    [value]="total | number"></dcc-billboard>

  <input
    class="company-id"
    placeholder="Company ID"
    type="text"
    [(ngModel)]="query.companyId" />

  <multiselect-dropdown
    placeholderCategoryPlural="Platforms Selected"
    placeholderCategorySingular="Platform Selected"
    placeholderLabel="Select Platforms"
    [enableClearItems]="true"
    [initialItems]="initialPlatforms"
    [items]="platforms"
    [zIndex]="101"
    (onItemSelected)="selectPlatforms($event)"></multiselect-dropdown>

  <input
    class="can-type"
    placeholder="Can1"
    type="text"
    [(ngModel)]="query.can1Type" />

  <dcc-loading-indicator
    *ngIf="isLoading"
    class="button-group"></dcc-loading-indicator>

  <dcc-search-button
    *ngIf="!isLoading"
    (search)="onSearchClick()"></dcc-search-button>
  <dcc-reset-button
    *ngIf="!isLoading"
    (reset)="reset()"></dcc-reset-button>
  <dcc-spacer></dcc-spacer>

  <!-- ng-content for additional buttons -->
  <ng-content></ng-content>
</div>

<div
  *ngIf="options.showAdvanced"
  class="advanced-filters">
  <div>
    <button
      class="query-builder__advanced__filter after lx-btn lx-btn-text"
      (click)="addDateRangeStartFilter()">
      + Signal After
    </button>
    <button
      class="query-builder__advanced__filter before lx-btn lx-btn-text"
      (click)="addDateRangeEndFilter()">
      + Signal Before
    </button>
    <button
      class="query-builder__advanced__filter equals lx-btn lx-btn-text"
      (click)="addExactValueFilter()">
      + Equals
    </button>
    <button
      class="query-builder__advanced__filter greater-than lx-btn lx-btn-text"
      (click)="addValueRangeStartFilter()">
      + Greater Than
    </button>
    <button
      class="query-builder__advanced__filter less-than lx-btn lx-btn-text"
      (click)="addValueRangeEndFilter()">
      + Less Than
    </button>
    <button
      class="query-builder__advanced__filter less-than lx-btn lx-btn-text"
      (click)="addExistsFilter()">
      + Exists
    </button>
    <button
      class="query-builder__advanced__filter less-than lx-btn lx-btn-text"
      (click)="addDoesNotExistFilter()">
      + Does Not Exist
    </button>
  </div>
  <span
    *ngFor="let filter of query.filters"
    class="query-builder__advanced__filter query-builder__advanced__filter">
    <app-query-filter
      [filter]="filter"
      (delete)="deleteFilter($event)"></app-query-filter>
  </span>
</div>
